import Theme from './icons/theme'
import LatexIcons from './icons/latex';
import utils from './utils';
/**
 * 编辑器主题模版类
 * @description
 */
class Template {
  constructor(editor) {
      this.editor = editor;
      this.theme = this.editor.options.theme || 'simple';
      this.outterContainer = null;
      this.IconsTheme = Theme[this.theme];
      this.initOutterContainer();
      this.initTemplate();
  }
  /**
   * 初始化外层载体
   * @description
   */
  initOutterContainer () {
      const outterContainer = document.querySelector('.useditor-outter-container');
      if (!outterContainer) {
          const containner = document.createElement('div');
          containner.classList.add('useditor-outter-container');
          document.body.append(containner);

          const viewport = document.createElement("meta");
          viewport.setAttribute('name', 'viewport')
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;');
          document.head.prepend(viewport)
      }
      this.outterContainer = document.querySelector('.useditor-outter-container');
      this.outterContainer.classList.add('usmobile')
      // const placeholderContainer = document.querySelector('.editor-placeholder');
      // if (!placeholderContainer) {
      //   const placeholder = document.createElement('div');
      //   placeholder.classList.add('editor-placeholder');
      //   placeholder.classList.add('hide');
      //   document.body.append(placeholder);
      // }
  }
  /**
   * 初始化模版
   * @description
   */
  initTemplate() {
      const yEditor = document.querySelector(`.y-editor-${this.editor.options.id}`);
      if (yEditor) yEditor.remove();
      const footerEl = document.createElement('div');
      footerEl.classList.add('mt-editor-keyboard');
      footerEl.classList.add(`y-editor-${this.editor.options.id}`);
      if (this.editor.options.bottom) {
        footerEl.classList.add(`y-editor-bottom-margin`);
      }
      footerEl.classList.add(`y-editor-${this.theme}`);
      footerEl.classList.add('hide');
      this.container = footerEl;
      this.outterContainer.append(this.container);

      const editor_id = this.editor.options.id;

      const defaultLatexButton = this.editor.default_toolbar_buttons;

      this.moreCommonLatexs = [];
      this.commonLatexs = defaultLatexButton;
      if (defaultLatexButton.length > 25) {
        this.moreCommonLatexs = defaultLatexButton.slice(25)
      }

      const courseGrade = this.editor.options.grade || 0;  // 课程年级
      let keyboardContent = '';
      if (courseGrade >= 5) {
        // 左中右布局，中间灰色部分支持上下滚动
        const calculationButtons = this.renderLatexButtons("calculation");
        const complexButtons = this.renderLatexButtons("complex").replace(/<li>/g, '<div class="digit-item">').replace(/<\/li>/g, '</div>');
        const numberButtons = this.renderLatexButtons("number");
        keyboardContent = `
          <div class="matheditor-left-keyboard">
            <div class="left-panel">
              <ul class="calculation-buttons">${calculationButtons}</ul>
            </div>
            <div class="middle-panel">
              <div class="scrollable-middle">${complexButtons}</div>
            </div>
            <div class="right-panel">
              <ul class="number-buttons">${numberButtons}</ul>
            </div>
          </div>
        `;
      } else {
        keyboardContent = `
          <div class="matheditor-right-digits">
            <ul class="matheditor-digits">${this.renderLatexButtons("digit")}</ul>
          </div>
        `;
      }

      this.container.innerHTML =
        '<div class="matheditor-title">\
        <div class="matheditor-title-left">\
          <a class="matheditor-title-btn matheditor-switch-btn" href="javascript:void(0)">ABC</a>\
          <a class="matheditor-title-btn matheditor-switchback-btn hide" href="javascript:void(0)">123/!?#</a>\
        </div>\
        <div class="matheditor-title-right">\
          <a class="matheditor-arrow-btn matheditor-previous-input hide" href="javascript:void(0)">' + this.IconsTheme.arrowLeft + '</a>\
          <a class="matheditor-arrow-btn matheditor-next-input hide" href="javascript:void(0)">' + this.IconsTheme.arrowRight + '</a>\
          <a class="matheditor-close-btn" href="javascript:void(0)">' +
        this.IconsTheme.ipadClose +
        '</a>\
        </div>\
      </div>\
      <div class="matheditor-wrap">\
        <section class="matheditor-main">\
          <div id="matheditor-general-' +
        editor_id +
        '" class="matheditor-general-content">\
            <div class="matheditor-general-main">\
              ' + keyboardContent + '\
              <div class="matheditor-general-right">\
                <div class="matheditor-right-operation">\
                  <a class="matheditor-del-btn matheditor-delete-btn" href="javascript:void(0)">' +
        this.IconsTheme.delete +
        '</a>\
                  <ul class="matheditor-high-frequency">' +
        this.renderLatexButtons("highFrequency") +
        '</ul>\
                </div>\
              </div>\
            </div>\
          </div>\
          <div id="matheditor-en-' +
        editor_id +
        '" class="matheditor-en-content" style="display: none;">\
            <div class="matheditor-en-main"><div class="matheditor-letter-list">' +
        this.renderLetterButtons() +
        "</div><div class='matheditor-en-right'>" +
        '<div class="matheditor-right-operation">\
                  <a class="matheditor-del-btn matheditor-delete-btn" href="javascript:void(0)">' +
        this.IconsTheme.delete +
        '</a>\
                  <ul class="matheditor-high-frequency">' +
        this.renderLatexButtons("highFrequency") +
        "</ul></div>" +
        "</div></section></div>";
      this.editorLatexContentEl = document.querySelector(`#matheditor-general-${editor_id}`);
      this.editorEnContentEl = document.querySelector(`#matheditor-en-${editor_id}`);

      this.switchBtn = document.querySelector(`.y-editor-${editor_id} .matheditor-switch-btn`);
      this.switchbackBtn = document.querySelector(
        `.y-editor-${editor_id} .matheditor-switchback-btn`
      );

      this.closeBtns = document.querySelectorAll(`.y-editor-${editor_id} .matheditor-close-btn`);
      this.deleteBtns = document.querySelectorAll(`.y-editor-${editor_id} .matheditor-delete-btn`);
      this.previousInputs = document.querySelectorAll(
        `.y-editor-${editor_id} .matheditor-previous-input`
      );
      this.nextInputs = document.querySelectorAll(
        `.y-editor-${editor_id} .matheditor-next-input`
      );
      // this.switchHwrBtns = document.querySelectorAll(`.y-editor-${editor_id} .matheditor-hwr-btn`);
  }
  /**
   * 渲染各分类公式集
   * @param {string} latexType 公式分类
   */
  renderLatexButtons (latexType) {
    let subTabTemplateHtml = '';

    const courseGrade = this.editor.options.grade || 0;  // 课程年级

    const baseDigitButtonsHigh = [
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "zero",
      "compare",
      "plus",
      "reduce",
      "multiplication",
      "division",
      "dot",
      "comma",
      "xie",
      "percent",
      "round_brackets",
      "less_than",
      "greater_than",
      "less_equal",
      "greater_equal",
      "equal",
      "ne",
      "fraction",
      "r_superscript",
    ];

    const baseDigitButtonsLow = [
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "zero",
      "",
      "compare",
      "plus",
      "reduce",
      "multiplication",
      "division",
      "dot",
      "comma",
      "xie",
      "",
      "less_than",
      "greater_than",
      "less_equal",
      "greater_equal",
      "equal",
      "ne",
    ];

    let digitButtons = [...baseDigitButtonsLow];

    // 如果courseGrade不是23、24、25，且大于等于3，才添加fraction和r_superscript
    if (![23, 24, 25].includes(courseGrade) && courseGrade >= 3) {
      digitButtons = [...baseDigitButtonsHigh];
    }

    const latexButtons = {
      // 数字符号
      digit: digitButtons,
      calculation: [
        "plus",
        "reduce",
        "multiplication",
        "division",
        "equal",
        "ne",
        "compare",
        "xie",
        "less_than",
        "greater_than",
        "less_equal",
        "greater_equal",
      ],
      complex: [
        "fraction",
        "square_root",
        "cube_root",
        "pi_common",
        "percent",
        "modulus_common",
        "approx",
        "plus_minus",
        "angle",
        "degree",
        "r_superscript",
        "round_brackets",
        "overrightarrow",
        "overleftrightarrow",
        "overline",
      ],
      number: [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "zero",
        "dot",
        "comma",
      ],
      // 全学段高频符号（斜杠、比、百分号）
      highFrequency: ["space"],
      // 比较符号
      compare: ["equal", "less_than", "greater_than"],
      // 常用符号
      common: this.commonLatexs,
    };
    const curLatexButtons = latexButtons[latexType || 'common']
    curLatexButtons.forEach(btn =>  {
      if (this.editor.buttonMeta[btn]) {
        const icon = this.editor.buttonMeta[btn].title || LatexIcons[this.editor.buttonMeta[btn].icon] || this.editor.buttonMeta[btn].latexicon;
        subTabTemplateHtml += "<li><a href='javascript:void(0)' class='matheditor-btn-span " + this.theme + "-btn-span' title='" + this.editor.buttonMeta[btn].name +
        "' data-latex='" + this.editor.buttonMeta[btn].latex +
        "' data-moveto='" + this.editor.buttonMeta[btn].moveto +
        "' data-movefor='" + this.editor.buttonMeta[btn].movefor +
        "' id='matheditor-btn-" + btn +
        "' class='op-btn'>"+ icon +
        "</a></li>";
      } else {
        subTabTemplateHtml += '<li><span class="matheditor-btn-placeholder">&nbsp;</span></li>';
      }
    })
    return subTabTemplateHtml
  }
  /**
   * 渲染英文字母
   * @description
   */
  renderLetterButtons (isZhLetters) {
    let templateHtml = ""
    templateHtml += "<ul class='matheditor-letter-line'>"
    this.editor.keyboardKeys.letters.forEach((item, index) => {
      const val = item.value
      const display = item.display
      if (val.toLowerCase() == 'capslock' || val.toLowerCase() == 'backspace' || val.toLowerCase() == 'close') {
        templateHtml += "<li class='matheditor-letter-handle'>" + (!isZhLetters || (isZhLetters && (val.toLowerCase() == 'backspace' || val.toLowerCase() == 'close')) ? "<a href='javascript:void(0)' class='matheditor-btn-span " + this.theme + "-btn-span btn-"+ val +"' title='" + item.name + "' data-latex='" + val + "' data-moveto='Right' data-movefor='1' id='matheditor-btn-" + index + "' class='op-btn'>"+ this.IconsTheme['ipad' + val] + "</a>" : "") + "</li>"
                     + (item.new_line ? "</ul><ul class='matheditor-letter-line'>" : "")
      } else if (val.toLowerCase() == 'formula') {
        templateHtml += "<li class='matheditor-letter-handle'><a href='javascript:void(0)' class='matheditor-btn-span " + this.theme + "-btn-span btn-"+ val +"' title='" + item.name + "' data-latex='" + val + "' data-moveto='Right' data-movefor='1' id='matheditor-btn-" + index + "' class='op-btn'>"+ display + "</a></li>"
                     + (item.new_line ? "</ul><ul class='matheditor-letter-line'>" : "")
      } else {
        templateHtml += "<li><a href='javascript:void(0)' class='matheditor-btn-span matheditor-btn-span-letter " + this.theme + "-btn-span' title='" + val + "' data-latex='" + val + "' data-moveto='Right' data-movefor='1' id='matheditor-btn-" + index + "' class='op-btn'>"+ item.display +"</a></li>"
                     + (item.new_line ? "</ul><ul class='matheditor-letter-line'>" : "")
      }
    })
    templateHtml += "</ul>"
    return templateHtml
  }
}
 export default Template;
